import React from 'react';
import styled from 'styled-components';

import { humanizeEnum } from '../../utils';
import { FlatTable } from './flatTable';

interface Props {
  object: any;
}

export function ObjectPreview(props: Props) {
  if (!props.object) {
    return null;
  }

  const format = (object: any) => {
    if (typeof object === 'boolean') {
      return object ? 'true' : 'false';
    }

    if (typeof object === 'object') {
      return <ObjectPreview object={object} />;
    }

    if (object === null) {
      return 'null';
    }

    return object;
  };

  return (
    <Table>
      {Object.keys(props.object).map((key) => (
        <tr key={key}>
          <td>{humanizeEnum(key)}:</td>
          <td>{format(props.object[key])}</td>
        </tr>
      ))}
    </Table>
  );
}

const Table = styled(FlatTable)`
  max-width: 100%;

  td {
    &:first-of-type {
      text-align: right;
      font-weight: bold;
    }

    padding: 0.5em;

    min-width: 10em;
    word-break: break-all;
    white-space: pre-wrap;
  }

  table {
    margin: -0.25em;

    td {
      word-break: none;
      padding: 0.25em;
      border: 0;
      min-width: 4em;

      &:first-of-type {
        text-align: left;
      }
    }
  }
`;
